var DATEPICKER_POPPER_BASE_MODIFIERS = [{
  name: 'offset',
  options: {
    offset: [0, 2]
  }
}];

export { DATEPICKER_POPPER_BASE_MODIFIERS };
